import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { SUBJECTS, GRADES } from '../constants';

/**
 * 生徒のタスクデータをExcelファイルとして書き出す
 * @param {Object} selectedStudent - 選択された生徒情報
 * @param {Object} tasks - タスクデータ
 * @returns {Promise<void>}
 */
export const exportStudentTasksToExcel = async (selectedStudent, tasks) => {
  if (!selectedStudent) {
    alert('生徒を選択してください。');
    return;
  }

  const studentId = selectedStudent.id;
  
  // 全ての科目のタスクデータを取得
  const exportData = [];
  SUBJECTS.forEach((subject) => {
    const key = `${studentId}-${subject.id}`;
    const subjectTasks = tasks[key];
    
    if (subjectTasks) {
      Object.values(subjectTasks).forEach((task) => {
        Object.values(task.items || {}).forEach((item) => {
          exportData.push({
            生徒名: selectedStudent.name,
            学年: GRADES.find(g => g.id === selectedStudent.grade)?.name || '',
            科目: subject.name,
            課題名: task.title,
            チェック項目: item.text,
            課題期限: item.dueDate || '',
            確認テスト日時: item.testDate || '',
            確認テストスコア: item.testScore || '',
            チェックボックス: item.checked ? 'TRUE' : 'FALSE',
            教師確認: item.teacherCheck || '未確認',
            合否判定: item.passFailStatus || '',
          });
        });
      });
    }
  });

  if (exportData.length === 0) {
    alert('対象生徒に登録されている課題がありません。');
    return;
  }

  // エクセルワークブックとワークシートの作成
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Tasks');
  
  // ヘッダーを手動で設定
  const headers = ['生徒名', '学年', '科目', '課題名', 'チェック項目', '課題期限', '確認テスト日時', '確認テストスコア', 'チェックボックス', '教師確認', '合否判定'];
  worksheet.addRow(headers);
  
  // データを追加
  exportData.forEach(row => {
    worksheet.addRow([
      row.生徒名, row.学年, row.科目, row.課題名, row.チェック項目,
      row.課題期限, row.確認テスト日時, row.確認テストスコア,
      row.チェックボックス, row.教師確認, row.合否判定
    ]);
  });

  // エクセルファイルのバイナリデータを取得
  const excelBuffer = await workbook.xlsx.writeBuffer();

  // Blobオブジェクトの作成
  const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

  // ファイルのダウンロード
  saveAs(
    data,
    `${selectedStudent.name}_tasks_${new Date().toISOString().slice(0, 10)}.xlsx`
  );
}; 